export { default } from "./navigation-link-indicator";
